import React from 'react';
import { Col, Row } from 'reactstrap';

import CGIAR_NEW from '../../../assets/Images/cgiar_neww.svg';
import IWMI_NEW from '../../../assets/Images/iwmi_neww.svg';
import WAPOR_LOGO from '../../../assets/Images/WaPOR_wordmark-removebg.png';

function BulletinFooter() {
  return (
    <>
      <div className="bulletin-footer-container">
        <Row>
          <Col xs={1} className="bulletin-disclaimer-header pr-0">
            Disclaimer :
          </Col>
          <Col xs={11} className="bulletin-disclaimer-text p-0">
            All content within this bulletin is based upon the most current available data. As the
            drought is a dynamic situation, the current realities may differ from what is depicted
            in this document. The content is generated only with remote sensing data and weather
            forecast and requires validation. We welcome the feedback from the end-users and request
            you to provide field observations and any other details which can improve the product
            quality and prediction skills.
          </Col>
        </Row>
      </div>
      <div className="bulletin-footer">
        <div className="bulletin-footer-data">
          <p className="bulletin-footer-text m-0">
            For further information please contact :
            {/* <a href={`mailto:wrd@iwmi.org`} className="email-font-color ">
              {' '}
              wrd@iwmi.org
            </a> */}
            <a href="#" className="email-font-color ">
              <p>Direction Nationale de l’Agriculture Rue Mohamed V,</p>
              
              {
                '  \n Porte 74, BP: 1098, Bamako, Mali     '  
              }
              <a
                href="tel:+22320222877"
                className="email-font-color"
                aria-label="Call +223 20 22 28 77"
              >
                    +223 20 22 28 77
              </a>
            </a>
          </p>
          <div>
            <img src={IWMI_NEW} alt="Logos" className="logos" />
            <img src={CGIAR_NEW} alt="Logos" className="logos" />
            <img src={WAPOR_LOGO} alt="Logos" className="logos logos-ml logos-wapor" />
          </div>
        </div>
        <div>
          <p className="text-center m-0">
            <span className="copy-icon">&copy;</span>
            <a
              className="copyright-text climber-footer"
              href="https://www.iwmi.cgiar.org/copyright/"
              target="_blank"
              rel="noreferrer"
            >
              {new Date().getFullYear()} International Water Management Institute | Terms of use
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export default BulletinFooter;
